import Logo from '../logo.svg';

export const ReactLogo = () => {
  return (
    <img 
      src={ Logo } 
      alt="React Logo" 
      className="logo"
    />
  )
}
